import { LOADING } from "../../../constants/constant";
import {
  GET_ALL_USERS_FAILED_ADMIN_PORTAL,
  GET_ALL_USERS_SUCCESS_ADMIN_PORTAL,
  GET_ALL_USERS_REQUESTED_ADMIN_PORTAL,
  GET_ALL_USERS_RESET_ADMIN_PORTAL,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getAllUsersAdminPortalReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_USERS_REQUESTED_ADMIN_PORTAL:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_ALL_USERS_SUCCESS_ADMIN_PORTAL:
      let userRes = Object.assign({}, state);
      console.log(
        "get All Users in getAllUsersAdminportal reducer=> Case => Success:" +
          JSON.stringify(action.data)
      );
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      userRes.isLoading = false;
      //   userRes.statusCode = action.data.status;
      userRes.data = action.data.data.data;

      return userRes;

    case GET_ALL_USERS_FAILED_ADMIN_PORTAL:
      console.error(
        "get all users Reducer => Case => Failed:" +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);

    case GET_ALL_USERS_RESET_ADMIN_PORTAL: {
      return initialState;
    }

    default:
      return state;
  }
}
